module.exports = __webpack_public_path__ + "img/qihui_home_image_idpage@2x.bf154996.png";